<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps(['classes', 'params', 'fillWidth', 'name'])

const classesRef = computed(() => {
  const result = ['kama-col']

  if (props.classes) {
    result.push(props.classes)
  }

  const params = props.params

  if (params && Object.keys(params).length > 0) {
    for (const key in params) {
      // 'cols' пропустим, он нужен для VCol (vuetify)
      if (key === 'cols') {
        continue
      }

      result.push(`kama-col-${key}-${params[key]}`)
    }
  }

  return result.join(' ')
})
</script>

<template>
  <div
    v-if="fillWidth"
    class="kama-col-fill-width"
  >
    <KamaCol
      :key="props.name"
      :classes="props.classes"
      :params="props.params"
    >
      <slot />
    </KamaCol>
  </div>
  <div
    v-else
    :class="classesRef"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/variables.scss' as vars;
@use "sass:map";
@use "sass:math";

.kama-col {
  box-sizing: border-box;
  width: 100%;
  float: left;
  padding: vars.$kama-col-padding;
  position: relative;
  min-height: 72px;
  align-content: end;
}

.kama-col-fill-width {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}

// https://youtrack.uchi.red/issue/gorn-513 пункт 1
// min-height мы задаем для полей фильтров в первую очередь
// type data там использоваться не будут
.kama-col.field-type-data {
  min-height: 0;
}

@mixin generate-grid($prefix) {
  @for $i from 1 through 12 {
    &#{$prefix}-#{$i} {
      width: math.percentage(math.div($i, 12));
    }
  }
}

// sm — всегда (по умолчанию)
.kama-col {
  @include generate-grid('-sm');
}

// md, lg, xl
$breakpoints: (
  md: 'sm-and-up',
  lg: 'md-and-up',
  xl: 'lg-and-up',
);

@each $bp, $query in $breakpoints {
  @media #{map.get(vars.$display-breakpoints, $query)} {
    .kama-col {
      @include generate-grid('-#{$bp}');
    }
  }
}
</style>
